import { render, staticRenderFns } from "./Analyies.vue?vue&type=template&id=00b54450&scoped=true"
import script from "./Analyies.vue?vue&type=script&lang=js"
export * from "./Analyies.vue?vue&type=script&lang=js"
import style0 from "./Analyies.vue?vue&type=style&index=0&id=00b54450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b54450",
  null
  
)

export default component.exports